import { API_PATH } from '../base';
import { APP_CONFIG } from '../base';
import { getAppDefaultMessage } from '../dictionary';

export { goFish, abort, goUrl };

// http://dp-app.i-g.pl/swagger/ui/index#/

const API_POST_HEADER = 'application/json';
const CACHE_AVAILABLE = 'caches' in self;
const API_CACHE_NAME = 'iapicache';
const URL_CACHE_NAME = 'gourlcache';

const getApiUrl = (group: keyof AppAPIGroups, request: APIRequestId) => {
    let url = '';
    if (APP_CONFIG.api[group]) {
        // TODO soothe TS
        url = API_PATH + (APP_CONFIG.api[group][request] || '');
    }
    return url;
};

const API_CALLS: APIConfig = {
    list: {
        id: 'list',
        url: getApiUrl('locals', 'list'),
        method: 'GET',
        cache: true,
        cacheMinutes: 4
    },
    city: {
        id: 'city',
        url: getApiUrl('locals', 'city'),
        method: 'GET'
    },
    local: {
        id: 'local',
        url: getApiUrl('locals', 'local'),
        method: 'GET'
    },
    getcurrent: {
        id: 'getcurrent',
        url: getApiUrl('locals', 'getcurrent'),
        method: 'GET'
    },
    setcurrent: {
        id: 'setcurrent',
        url: getApiUrl('locals', 'setcurrent')
    },
    citysearch: {
        id: 'citysearch',
        url: getApiUrl('locals', 'citysearch'),
        method: 'GET',
        cache: true
    },
    streetsearch: {
        id: 'streetsearch',
        url: getApiUrl('locals', 'streetsearch'),
        method: 'GET',
        cache: true
    },

    getproductlist: {
        id: 'getproductlist',
        method: 'GET',
        url: getApiUrl('products', 'getproductlist'),
        cache: true
    },
    getproductdetails: {
        id: 'getproductdetails',
        method: 'GET',
        url: getApiUrl('products', 'getproductdetails')
    },
    getpromotiondetails: {
        id: 'getpromotiondetails',
        method: 'GET',
        url: getApiUrl('products', 'getpromotiondetails')
    },
    getrecommendedtoppings: {
        id: 'getrecommendedtoppings',
        method: 'GET',
        url: getApiUrl('products', 'getrecommendedtoppings'),
        cache: true
    },
    getcreatorproductlist: {
        id: 'getcreatorproductlist',
        method: 'GET',
        url: getApiUrl('products', 'getcreatorproductlist')
    },
    getpromotionproductdetails: {
        id: 'getpromotionproductdetails',
        method: 'GET',
        url: getApiUrl('products', 'getpromotionproductdetails')
    },
    useupsellpromotion: {
        id: 'useupsellpromotion',
        method: 'POST',
        url: getApiUrl('products', 'useupsellpromotion')
    },

    status: {
        id: 'status',
        method: 'POST',
        url: getApiUrl('user', 'status')
    },
    getuserorder: {
        id: 'getuserorder',
        method: 'POST',
        url: getApiUrl('user', 'getuserorder')
    },
    getuserorders: {
        id: 'getuserorders',
        method: 'POST',
        url: getApiUrl('user', 'getuserorders')
    },

    config: {
        id: 'config',
        method: 'POST',
        url: getApiUrl('delivery', 'config')
    },

    addproduct: {
        id: 'addproduct',
        method: 'POST',
        url: getApiUrl('cart', 'addproduct')
    },
    addconversion: {
        id: 'addconversion',
        method: 'POST',
        url: getApiUrl('cart', 'addconversion')
    },
    addpizza: {
        id: 'addpizza',
        method: 'POST',
        url: getApiUrl('cart', 'addpizza')
    },
    editpizza: {
        id: 'editpizza',
        method: 'POST',
        url: getApiUrl('cart', 'editpizza')
    },
    addcoupon: {
        id: 'addcoupon',
        method: 'POST',
        url: getApiUrl('cart', 'addcoupon')
    },
    editcoupon: {
        id: 'editcoupon',
        method: 'POST',
        url: getApiUrl('cart', 'editcoupon')
    },
    addcreator: {
        id: 'addcreator',
        method: 'POST',
        url: getApiUrl('cart', 'addcreator')
    },
    editcreator: {
        id: 'editcreator',
        method: 'POST',
        url: getApiUrl('cart', 'editcreator')
    },
    delproduct: {
        id: 'delproduct',
        method: 'POST',
        url: getApiUrl('cart', 'delproduct')
    },
    getcart: {
        id: 'getcart',
        method: 'POST',
        url: getApiUrl('cart', 'getcart')
    },
    getsummary: {
        id: 'getsummary',
        method: 'POST',
        url: getApiUrl('cart', 'getsummary')
    },
    checkout: {
        id: 'checkout',
        method: 'POST',
        url: getApiUrl('cart', 'checkout')
    },
    checkoutstatus: {
        id: 'checkoutstatus',
        method: 'POST',
        url: getApiUrl('cart', 'checkoutstatus')
    },
    addorder: {
        id: 'addorder',
        method: 'POST',
        url: getApiUrl('cart', 'addorder')
    },

    add: {
        id: 'add',
        method: 'GET',
        url: getApiUrl('favorite', 'add')
    },
    del: {
        id: 'del',
        method: 'GET',
        url: getApiUrl('favorite', 'del')
    },
    favlist: {
        id: 'favlist',
        method: 'GET',
        url: getApiUrl('favorite', 'favlist')
    },

    getorderstatus: {
        id: 'getorderstatus',
        method: 'POST',
        url: getApiUrl('order', 'getorderstatus')
    },

    couponsuse: {
        id: 'couponsuse',
        method: 'POST',
        url: getApiUrl('coupons', 'couponsuse')
    },
    getguid: {
        id: 'getguid',
        method: 'POST',
        url: getApiUrl('coupons', 'getguid')
    },
    geturl: {
        id: 'geturl',
        method: 'POST',
        url: getApiUrl('coupons', 'geturl')
    },
    conversion: {
        id: 'conversion',
        method: 'POST',
        url: getApiUrl('onlinemarketing', 'conversion')
    }
};

type FetchControler = {
    [key in APIRequestId]?: {
        [key: string]: AbortController;
    };
};

const fetchController: FetchControler = {};

/**
 *
 */
function abort(api: APIRequestId, data?: string) {
    if (fetchController[api]) {
        if (!data) {
            if (fetchController[api][api]) {
                Object.values(fetchController[api][api]).map(c => c && c.abort());
                fetchController[api][api] = null;
            }
        } else {
            if (fetchController[api][data]) {
                fetchController[api][data]?.abort();
                fetchController[api][data] = null;
            }
        }
    }
}

async function goFish(fishingParams: APICall) {
    const dataString = fishingParams.data ? JSON.stringify(fishingParams.data) : fishingParams.api;
    // Wait for previous call if pending to serve cached response
    if (
        API_CALLS[fishingParams.api].cache && CACHE_AVAILABLE &&
        fetchController[fishingParams.api] && fetchController[fishingParams.api][dataString]
    ) {
        return goFishQueued(fishingParams);
    }
    // Cancel exact same call if cache is not available and previous is pending
    else {
        abort(fishingParams.api, dataString);
        return goFishNow(fishingParams);
    }
}

async function goFishNow({ api, data, cacheId, cacheMinutes }: APICall) {
    const dataString = data ? JSON.stringify(data) : api;

    // Setup new one
    const _abortControler = new AbortController();
    if (!fetchController[api]) {
        fetchController[api] = {};
    }
    fetchController[api][dataString] = _abortControler;
    // Prepare url for data
    let _url = API_CALLS[api].url;
    // console.log(_url, '_url1');
    // console.log(API_CALLS[api], 'API_CALLS[api]');
    
    let _fetchOptions: RequestInit = {
        method: API_CALLS[api].method || 'POST',
        signal: _abortControler.signal
    };

    if (data) {
        if (_fetchOptions.method == 'POST') {
            _fetchOptions.body = JSON.stringify(data);
            _fetchOptions.headers = {
                'Content-Type': API_POST_HEADER
            };
        } else if (_fetchOptions.method == 'GET') {
            for (let val in data) {
                _url = _url.replace(`{${val}}`, data[val]);
            }
        }
    }

    // Unique cache url
    const cacheMark = cacheId ? `/${cacheId}${_url}` : _url;

    return checkAPICache(api, _url, _fetchOptions, cacheMinutes)
        .then(response => {
            if (response && response.ok) {
                // Found in cache
                console.log('%cAPI data from cache: ' + cacheMark, 'color:grey');
                // Cleanup after cache
                fetchController[api][dataString] = null;
                return response;
            } else {
                // Cache is empty or disabled so fetch
                console.log('%cAPI fetching data: ' + cacheMark, 'color:grey');
                return fetch(_url, _fetchOptions).then(resp => {
                    if (resp.status == 200) {
                        // Save response
                        putAPICache(api, cacheMark, _fetchOptions, resp.clone()).then(() => {
                            // Cleanup after call
                            console.log('%cAPI request cleanup after call: ' + cacheMark, 'color:grey');
                            fetchController[api][dataString] = null;
                        });
                    }
                    // Proceed
                    return resp;
                });
            }
        })
        .then(res => {
            if (res.status >= 200 && res.status < 500) {
                return res;
            } else {
                throw { Message: getAppDefaultMessage('errors.server'), name: '500' };
            }
        })
        .then(res => {
            let _resp = API_CALLS[api].resp || 'json';
            return res[_resp]();
        })
        .catch(error => {
            return Promise.reject({
                Status: false,
                Message: error.Message || '',
                Code: error.name
            });
        });
}

async function goFishQueued(fishingParams: APICall): Promise<any> {
    return new Promise(resolve => {
        console.log('%cAPI request lured: ' + fishingParams.api, 'color:grey');
        let tries = 5;
        const dataString = fishingParams.data
            ? JSON.stringify(fishingParams.data)
            : fishingParams.api;

        const lureFish = () => {
            console.log('%cAPI try: ' + (6 - tries), 'color:grey');
            tries--;
            if (
                fetchController[fishingParams.api] &&
                fetchController[fishingParams.api][dataString] &&
                tries > 0
            ) {
                setTimeout(lureFish, 500);
            } else {
                resolve(goFishNow(fishingParams));
            }
        };

        lureFish();
    });
}

/**
 * Cached by default
 *
 * @param {string} url
 * @param {string} [method]
 * @param {boolean} [disableCache=false]
 * @param {boolean} [cacheId]
 * @returns
 */
async function goUrl({ url, method, disableCache = false, cacheId }: UrlAPICall) {
    const _fetchOptions: RequestInit = {
        method: method ? method : 'GET'
    };

    // Unique cache url
    const cacheMark = cacheId ? `/${cacheId}${url}` : url;

    return checkCache(URL_CACHE_NAME, cacheMark, _fetchOptions, disableCache)
        .then(response => {
            if (response && response.ok) {
                // Found in cache
                console.log('%cURL data from cache: ' + cacheMark, 'color:grey');
                return response;
            } else {
                // Cache is empty or disabled so fetch
                console.log('%cURL fetching data: ' + cacheMark, 'color:grey');
                return fetch(url, _fetchOptions).then(resp => {
                    if (resp.status == 200) {
                        if (!disableCache) {
                            // Save cache mark
                            sessionStorage.setItem(
                                URL_CACHE_NAME + cacheMark,
                                Date.now().toString()
                            );
                            // Save response
                            putCache(URL_CACHE_NAME, cacheMark, _fetchOptions, resp.clone());
                        }
                    }
                    // Proceed
                    return resp;
                });
            }
        })
        .then(res => {
            if (res.status >= 200 && res.status < 500) {
                return res;
            } else {
                throw { Message: getAppDefaultMessage('errors.server'), name: '500' };
            }
        })
        .then(res => {
            return res.json();
        })
        .catch(error => {
            return Promise.reject({
                Status: false,
                Message: error.Message || '',
                Code: error.name || ''
            });
        });
}

async function checkAPICache(
    api: APIRequestId,
    url: string,
    fetchOptions: RequestInit,
    cacheMinutes: number
) {
    if (API_CALLS[api].cache) {
        const minutes = cacheMinutes || API_CALLS[api].cacheMinutes || 15;
        return checkCache(API_CACHE_NAME, url, fetchOptions, false, minutes);
    }
}

async function putAPICache(
    api: APIRequestId,
    url: string,
    fetchOptions: RequestInit,
    response: Response
) {
    if (API_CALLS[api].cache) {
        // Save cache mark
        sessionStorage.setItem(API_CACHE_NAME + url, Date.now().toString());
        // Save response
        return putCache(API_CACHE_NAME, url, fetchOptions, response);
    }
}

/**
 * Get request from cache if exists.
 * If not return undefined.
 *
 * @param name
 * @param url
 * @param fetchOptions
 * @param disableCache
 * @param cacheDuration
 */
async function checkCache(
    name: string,
    url: string,
    fetchOptions: RequestInit,
    disableCache = false,
    cacheMinutes = 60
) {
    if (!disableCache && CACHE_AVAILABLE && fetchOptions.method === 'GET') {
        const cacheFlag = sessionStorage.getItem(name + url);
        // Storage is cleared
        if (!cacheFlag) {
            return;
        }
        // Is to old so delete
        else if (checkIfCacheDateIsOld(parseInt(cacheFlag), cacheMinutes)) {
            deleteCache(name, url);
            return;
        }
        try {
            const cache = await caches.open(name);
            return cache.match(new Request(url, fetchOptions));
        } catch (e) {}
    }
}

async function putCache(
    name: string,
    url: string,
    fetchOptions: RequestInit,
    response: Response,
    disableCache = false
) {
    if (!disableCache && CACHE_AVAILABLE && fetchOptions.method === 'GET') {
        try {
            const cache = await caches.open(name);
            cache.put(new Request(url, fetchOptions), response);
        } catch (e) {}
    }
}

async function deleteCache(name: string, url?: string) {
    if (CACHE_AVAILABLE) {
        try {
            if (url) {
                const cache = await caches.open(name);
                cache.delete(url, { cacheName: name } as CacheQueryOptions);
            } else {
                caches.delete(name);
            }
        } catch (e) {}
    }
}

/**
 *
 * @param time
 * @param duration
 */
const checkIfCacheDateIsOld = (time: number, minutes: number) => {
    const _date = new Date(time);
    _date.setHours(_date.getHours(), _date.getMinutes() + minutes);
    const _now = new Date();
    return _now.getTime() > _date.getTime();
};
